module.exports = __webpack_public_path__ + "img/ziliao_banner_hk.54a84703.jpg";